import { useFpB2bButlerService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-butler-service'
import { useCountUp } from '@dni-hooks/useCountUp'
import { Box } from '@pets-ui/Box/Box'
import { Lottie } from '@pets-ui/Lottie/Lottie'
import { Text } from '@pets-ui/Text/Text'
import * as stylex from '@stylexjs/stylex'
import { useEffect } from 'react'
import LoadingData from '../../assets/lottieFiles/loading.json'
import { useButler } from '../ButlerProvider/useButler'

const styles = stylex.create({
  body: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: 'calc(100vh - 56px)',
  },
  loadingContainer: {
    height: 160,
    width: 160,
  },
})

export const AiAnalyzing = () => {
  const { campaignId, platform } = useButler()
  const { startRetryTime } = useFpB2bButlerService(campaignId, platform)
  const defaultSeconds = Math.floor((new Date().getTime() - (startRetryTime ?? new Date()).getTime()) / 1000)
  const { startCountUp, stopCountUp, seconds } = useCountUp(defaultSeconds)

  useEffect(() => {
    startCountUp()
    return () => {
      stopCountUp()
    }
  }, [startCountUp, stopCountUp])

  return (
    <Box rootStyle={styles.body}>
      <Lottie animationDataProps={LoadingData} rootStyle={styles.loadingContainer} />
      <Text variant="subtitle">
        AI辨識中...
        {seconds}
        s
      </Text>
    </Box>
  )
}
